class StoreFinderService {

    /*@ngInject*/
    constructor($resource) {
        this.$resource = $resource;
    }

    StoreFinderSearch(address, resultsLimit) {

        var stores = this.$resource('/bathrooms/cart/public/retailOrder', {}, {
            searchStores: {
                method: 'GET',
                params: {address: address}
            }
        });

        return stores.searchStores().$promise.then(
            function(response) {
                var results = response.branches;
                results = results.slice(0, resultsLimit);
                return results;
            }
        );
    }
}

export default StoreFinderService;


// WEBPACK FOOTER //
// ./src/app/services/store-finder-service.js